import React from 'react';
import { Link } from 'react-router-dom';
import fallbackCoinIcon from '../assets/biticon.png';
import {
  formatCompactNumber,
  formatCurrency,
  formatPercent,
} from '../helpers/formatters';

export default function ListItems({ coin }) {
  return (
    <Link to={`/${coin.id}`} className="coin-card">
      <div className="coin-card__top">
        <div className="coin-card__identity">
          <img
            src={coin.image}
            alt={coin.name}
            loading="lazy"
            onError={(event) => {
              event.currentTarget.onerror = null;
              event.currentTarget.src = fallbackCoinIcon;
            }}
          />
          <div>
            <strong>{coin.name}</strong>
            <span>{coin.symbol || 'COIN'}</span>
          </div>
        </div>

        <span className="coin-card__rank">
          {coin.marketCapRank ? `#${coin.marketCapRank}` : 'Watch'}
        </span>
      </div>

      <div className="coin-card__price">{formatCurrency(coin.currentPrice)}</div>

      <div className="coin-card__meta">
        <span
          className={`coin-card__change ${
            coin.priceChange24h >= 0 ? 'green-text' : 'red-text'
          }`}
        >
          {formatPercent(coin.priceChange24h)}
        </span>
        <span className="coin-card__meta-value">
          MCap {formatCompactNumber(coin.marketCap)}
        </span>
      </div>
    </Link>
  );
}
